import React, { useEffect, useRef, useState } from 'react';
import './index.scss';

const PAPER_URL = 'https://arxiv.org/abs/2604.08491';

const LINKS: { id: string; label: string }[] = [
  { id: 'top', label: 'Home' },
  { id: 'concepts', label: 'Concepts' },
  { id: 'demo', label: 'Demo' },
  { id: 'cases', label: 'Cases' },
  { id: 'talks', label: 'Talks' },
];

// Sections that light up a nav item; the concept sub-sections all count as "Concepts"
const SPY_IDS = ['top', 'concepts', 'whatif', 'native', 'bad', 'versions', 'demo', 'cases', 'artifact', 'talks'];
const SPY_MAP: Record<string, string> = { whatif: 'concepts', native: 'concepts', bad: 'concepts', versions: 'concepts' };

const MyHeader: React.FC = () => {
  const [active, setActive] = useState<string>('top');
  // narrow screens: the section links and the paper button move into a dropdown behind a menu button
  const [open, setOpen] = useState(false);
  const navRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => entries.forEach((en) => {
        if (en.isIntersecting) setActive(SPY_MAP[en.target.id] || en.target.id);
      }),
      { rootMargin: '-40% 0px -55% 0px' },
    );
    SPY_IDS.forEach((id) => { const el = document.getElementById(id); if (el) io.observe(el); });
    return () => io.disconnect();
  }, []);

  useEffect(() => {
    if (!open) return;
    const onDown = (e: PointerEvent) => { if (!navRef.current?.contains(e.target as Node)) setOpen(false); };
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') setOpen(false); };
    const onResize = () => { if (window.innerWidth > 860) setOpen(false); };
    document.addEventListener('pointerdown', onDown);
    document.addEventListener('keydown', onKey);
    window.addEventListener('resize', onResize);
    return () => { document.removeEventListener('pointerdown', onDown); document.removeEventListener('keydown', onKey); window.removeEventListener('resize', onResize); };
  }, [open]);

  return (
    <nav className={'nav' + (open ? ' menu-open' : '')} ref={navRef}><div className="in">
      <a className="brand" href="#top" aria-label="llm-native figures"><b>llm-native</b><span>figures</span></a>
      {LINKS.map((l) => (
        <a key={l.id} className={'l' + (active === l.id ? ' on' : '')} href={'#' + l.id}>{l.label}</a>
      ))}
      <span className="sp" />
      <a className="btn sm o paper" href={PAPER_URL} target="_blank" rel="noopener noreferrer">Read the paper</a>
      <button type="button" className="menu" aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} aria-controls="navmenu" onClick={() => setOpen((o) => !o)}>
        <i /><i /><i />
      </button>
    </div>
    <div className="drop" id="navmenu" hidden={!open}>
      {LINKS.map((l) => (
        <a key={l.id} className={'dl' + (active === l.id ? ' on' : '')} href={'#' + l.id} onClick={() => setOpen(false)}>{l.label}</a>
      ))}
      <a className="btn sm o" href={PAPER_URL} target="_blank" rel="noopener noreferrer" onClick={() => setOpen(false)}>Read the paper</a>
    </div></nav>
  );
};

export default MyHeader;
